import React from "react";
import { Dropdown } from "react-bootstrap";
import { css } from "aphrodite";
import { DeviceForAlarmRingTone } from "../../lib/constant";
import styles from "./style";
import "./DeviceAlarmSelect.css";

const OPTIONS = [
  { value: DeviceForAlarmRingTone.none, label: "None" },
  { value: DeviceForAlarmRingTone.watchOnly, label: "Watch only" },
  { value: DeviceForAlarmRingTone.phoneOnly, label: "Phone only" },
  { value: DeviceForAlarmRingTone.phoneAndWatch, label: "Phone & Watch" },
];

function DeviceAlarmSelect({ value, onChange, disabled, id, "aria-label": ariaLabel }) {
  const normalizedValue = value || DeviceForAlarmRingTone.none;
  const selected =
    OPTIONS.find((option) => option.value === normalizedValue) || OPTIONS[0];

  return (
    <Dropdown
      className={css(styles.settingSelectDropdown)}
      onSelect={(key) => {
        if (!disabled) {
          onChange(key);
        }
      }}
    >
      <Dropdown.Toggle
        disabled={disabled}
        id={id}
        aria-label={ariaLabel}
        variant="light"
        className="monitoring-settings-select-toggle"
      >
        {selected.label}
      </Dropdown.Toggle>
      <Dropdown.Menu align="start" className="monitoring-settings-select-menu">
        {OPTIONS.map((option) => (
          <Dropdown.Item
            key={option.value}
            eventKey={option.value}
            active={option.value === normalizedValue}
          >
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default DeviceAlarmSelect;
